import { render, staticRenderFns } from "./SliderEN.vue?vue&type=template&id=2aac19d1&scoped=true"
import script from "./SliderEN.vue?vue&type=script&lang=js"
export * from "./SliderEN.vue?vue&type=script&lang=js"
import style0 from "./SliderEN.vue?vue&type=style&index=0&id=2aac19d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aac19d1",
  null
  
)

export default component.exports